export default __webpack_public_path__ + "static/media/tech-logo.cb1c8656.svg";